import React from 'react'
import Header from '../header/header'
import Main from '../main/main'
import Marquees from '../marquee/marquee'
import About from '../about/about'
import Solution from '../solution/solution'
import Coreteam from '../coreteam\'/coreteam'
import Client from '../client/client'
import Community from '../community/community'
import Footer from '../footer/footer'
import Investor from '../investor/investor'
import Service from '../service/service'
import Workflow from '../workflow/workflow'
import Popup from '../popup/popup'
import BrandletSlider from '../slider/slider'

import { useLocation } from "react-router-dom"

const HomePage = () => {

  const search = window.location.search;
   
  console.log(search);

  const referenceIdParams = new URLSearchParams(search);

  console.log(referenceIdParams);

  const partner_id = referenceIdParams.get("reference_id");

  console.log(partner_id);

  // const location = useLocation();
  
  // const queryParams = new URLSearchParams(location.search);
  // const reference_id = queryParams.get('reference_id');

  // console.log(reference_id);


  return (
    <div>
      <Header />
      <Main />
      <Marquees />
      <BrandletSlider />
      {/* <About /> */}
      <Service /> 
      <Solution /> 
      {/* <Coreteam />  */}
      <Investor />
      {/* <Client /> */}
      <Workflow />
      {/* <Community /> */}
      <Footer /> 
      <Popup />
    </div>
  )
}

export default HomePage